import React from 'react';
import { useTranslation } from 'react-i18next'; // For language handling
import { Link } from 'react-router-dom'; // Import Link from react-router-dom

import ngn from '../assets/images/ngn1.png'
import ngn2 from '../assets/images/ngn2.png';
import ngn3 from '../assets/images/ngn3.png';//KSA-GRF.png


function NGN() {
  const { t } = useTranslation(); // Hook for translation

  return (
    <div >
    {/* Hero Section */}
    <div className="hero-banner">
      <div className="hero-content" >
        <h1 style={{ color: 'black' }}>{t('ngn_title')}</h1>
        
      </div>
      
    </div>
    
    

    {/* Content Section */}
    <div className="hero-banner" style={{ backgroundColor: 'white' }}>
        <div className="hero-content">
          <p style={{ textAlign: 'justify' }}>{t('NGN_P1')}
          <ul>
          <li style={{ textAlign: 'justify' }}>{t('NGN_P1_1')}</li>
          <li style={{ textAlign: 'justify' }}>{t('NGN_P1_2')}</li>
          <li style={{ textAlign: 'justify' }}>{t('NGN_P1_3')}</li>
          </ul></p>
          <p style={{ textAlign: 'justify' }}><b>{t('NGN_P1_1')}</b></p>
          <p style={{ textAlign: 'justify' }}>{t('NGN_P2')}</p>
          <p style={{ textAlign: 'justify' }}><Link to="https://apps.geoportal.sa/PDFs/Geodesy/ngn/GASGI_NGN_AG%20locations%20(approximate).kmz" target='balnk'>{t('NGN_P2_URL')}</Link></p>
                 
          <img src={ngn} alt="Arrow Icon" style={{ width: '100%', height: 'auto', maxWidth: '600px' }} />
          <br /><br></br>     
          <p style={{ textAlign: 'justify' }}><b>{t('NGN_P1_2')}</b></p>
          <p style={{ textAlign: 'justify' }}>{t('NGN_P3')}</p>
          <p style={{ textAlign: 'justify' }}><Link to="https://apps.geoportal.sa/PDFs/Geodesy/ngn/GASGI_NGN_RG%20locations%20(approximate)%20(1).kmz" target='balnk'>{t('NGN_P3_URL')}</Link></p>
                 
          <img src={ngn2} alt="Arrow Icon" style={{ width: '100%', height: 'auto', maxWidth: '600px' }} />
          <br /><br></br>     
          <p style={{ textAlign: 'justify' }}><b>{t('NGN_P1_3')}</b></p>
          <p style={{ textAlign: 'justify' }}>{t('NGN_P4')}</p>
          <p style={{ textAlign: 'justify' }}><Link to="https://apps.geoportal.sa/PDFs/Geodesy/ngn/GASGI_NGN_RG%20locations%20(approximate)%20(1).kmz" target='balnk'>{t('NGN_P4_URL')}</Link></p>
                 
          <img src={ngn3} alt="Arrow Icon" style={{ width: '100%', height: 'auto', maxWidth: '600px' }} />
          <br /><br></br>
          <p style={{ textAlign: 'justify' }}><b>{t('NGN_P5')}</b>
          <ul>
          <li>{t('NGN_P5_1')} </li>
          <li>{t('NGN_P5_2')} </li>
          <li>{t('NGN_P5_31')} <a
              href={`mailto:${t('email_address')}`}
              target="_blank"
              rel="noopener noreferrer"
             
            > info@geosa.gov.sa</a> {t('NGN_P5_32')}</li>

            
            </ul></p>
          
          
          
          
          </div>
          
      </div>
      <div className="cards-space" style={{height:"40px"}}></div>
      
      
 
    
    </div>
);
}

export default NGN;
